import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ModalConfig, ModalRef, ModalService } from '@wfm/core';
import { ConfirmPatientMergeComponent } from './confirm-patient-merge/confirm-patient-merge.component';
import { WorkItem } from '@app/data-model/item/work-item';
import { PatientItem } from '@app/data-model/item/patient-item';
import { PatientDetails } from '@app/data-model/item/patient-detail';
import { MergePatientService } from './merge-patient.service';
import { AppConfigService } from '@app/common/app-config.service';
import { DataTransformationService } from '@app/common/data-transformation.service';

@Component({
  selector: 'app-merge-patient',
  templateUrl: './merge-patient.component.html',
  styleUrls: ['./merge-patient.component.scss']
})
export class MergePatientComponent implements OnInit {
  selectedWorkItem: WorkItem;
  sourcePatient: PatientDetails;
  destinationPatient: PatientDetails = {};
  showSearchForm = true;
  showSwapIcon = false;
  patientList: Array<PatientItem>;
  rightBoxTitle = 'mergePatient.search';
  patientSwapped = false;
  backButtonLabel: string;
  userDefaultDomain: string;
  searchFormValue = [];
  public hideMainModel = false;
  allowSwap = true;

  constructor(
    public config: ModalConfig,
    public modalRef: ModalRef,
    public cd: ChangeDetectorRef,
    private modalService: ModalService,
    public mergePatientService: MergePatientService,
    private appConfigService: AppConfigService,
    private dataTransformationService: DataTransformationService
  ) {}

  ngOnInit(): void {
    this.userDefaultDomain = this.appConfigService.getUserDefaultDomain();
    if (this.config && this.config.data) {
      this.selectedWorkItem = this.config.data.item;
      this.prepareSourcePatientInfo();
    }
  }

  prepareSourcePatientInfo() {
    let mrn = this.selectedWorkItem.mrn;
    mrn.domainIdentifierName = this.userDefaultDomain;
    if (!mrn.domainIdentifier) {
      mrn = this.fetchMrnData(JSON.parse(JSON.stringify(mrn)));
    }
    const name = this.selectedWorkItem.patientNameObj
      ? this.selectedWorkItem.patientNameObj.text
      : this.selectedWorkItem.patientName.text;
    this.sourcePatient = new PatientDetails(
      this.selectedWorkItem.id,
      mrn,
      mrn.domainIdentifier,
      this.selectedWorkItem.patientId,
      name,
      this.selectedWorkItem.patientDoB,
      this.selectedWorkItem.patientGender
    );
  }

  openMergePatientConfirmation(event: Event) {
    this.hideMainModel = true;
    this.modalService
      .openModal(ConfirmPatientMergeComponent, {
        modalClass: 'modal--large',
        isBlockModal: true,
        isDecisionModal: true,
        data: {
          source: this.sourcePatient,
          destination: this.destinationPatient
        }
      })
      .afterClosed.subscribe(value => {
        if (value) {
          this.hideMainModel = false;
        } else {
          this.hideMainModel = false;
          this.closeModal(event);
        }
        this.cd.detectChanges();
      });
  }

  searchPatientList(searchFormValue) {
    this.searchFormValue = searchFormValue;
    this.mergePatientService
      .getPatientList(searchFormValue.pid, searchFormValue.patientName, searchFormValue.dob, searchFormValue.gender)
      .then((patientData: any) => {
        if (!patientData.error && patientData.length > 0) {
          patientData.forEach(patient => {
            patient['mrn'] = this.fetchMrnData(patient['identifier']);
          });
        }
        this.patientList = patientData.length ? patientData : [];
        this.displayPatientList();
        this.cd.detectChanges();
      });
  }

  selectDestinationPatient(selectedPatientInfo) {
    this.showSwapIcon = true;
    this.rightBoxTitle = 'mergePatient.selectedPatient';
    this.backButtonLabel = 'mergePatient.backToResults';
    this.destinationPatient = this.prepareDestinationPatient(selectedPatientInfo);
    this.cd.detectChanges();
  }

  fetchMrnData(mrn): any {
    const mrnResponse = this.dataTransformationService.filterDomainIdentifier(this.userDefaultDomain, mrn || []);
    mrnResponse.domainIdentifierName = this.userDefaultDomain;
    return mrnResponse;
  }

  prepareDestinationPatient(patient): PatientDetails {
    return new PatientDetails(
      patient.id,
      patient.mrn,
      patient.mrn.domainIdentifier,
      patient.patientId,
      patient.name.text,
      patient.birthDate,
      patient.gender
    );
  }

  goBack() {
    if (this.patientSwapped) {
      this.sourcePatient = this.destinationPatient;
    }
    if (this.rightBoxTitle === 'mergePatient.selectedPatient') {
      this.displayPatientList();
    } else if (this.rightBoxTitle === 'mergePatient.searchResults') {
      this.displaySearchForm();
    }
  }

  displaySearchForm() {
    this.showSearchForm = true;
    this.showSwapIcon = false;
    this.rightBoxTitle = 'mergePatient.search';
  }

  displayPatientList() {
    this.showSearchForm = false;
    this.showSwapIcon = false;
    this.destinationPatient = {};
    this.rightBoxTitle = 'mergePatient.searchResults';
    this.backButtonLabel = 'mergePatient.backToSearch';
  }

  manageSwapVisibility(enableSwap: boolean) {
    this.allowSwap = enableSwap;
  }

  swapPatient() {
    this.patientSwapped = !this.patientSwapped;
    const patient = this.sourcePatient;
    this.sourcePatient = this.destinationPatient;
    this.destinationPatient = patient;
  }

  closeModal(evt, response?) {
    evt.stopPropagation();
    this.modalRef.close(response);
  }
}
